window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap5');
window.Swal = require('sweetalert2')
window.Inputmask = require('inputmask');
require('datatables.net-bs4' );
require('datatables.net-buttons-bs4' );       
require('datatables.net-responsive-bs4' );  
require('datatables.net-buttons/js/buttons.html5.js');
require('select2');
require('jquery.repeater');
require('bootstrap-datepicker');
window.Compressor = require('compressorjs');
window.html2canvas =require('html2canvas');
window.html2pdf = require('html2pdf.js');
window.Cookies = require('js-cookie');
require('./act');
require('./pdf-generator');
window.Quill = require('quill');
window.katex = require('katex');
window.quillTableUI = require('quill-table-ui');
window.ImageResize = require('../lib/quill-image-resize-module/ImageResize');
import 'owl.carousel/dist/assets/owl.carousel.css';
require('owl.carousel');


window.app = {};
window.act = null;

$(document).ready(function () {

    $('.upgrade-alert-close').click(function(event){
        var $form = $(this).closest('.upgrade-alert');
        $form.trigger('submit');
        $form.remove();
    });

    $('.layout-sidebar-toggle-btn, .layout-sidebar-backdrop').click(function(event){
        event.preventDefault();
        $('body').toggleClass('layout-sidebar-open');
    });
    
    if($('.template-cards').length > 0) {
        $('.template-cards').animate({
            scrollTop: ( $(".template-card.active").offset().top - 300 )
        }, 1000); 
    }

    $('.profile-switch .profile-account').on('click', function(event){
        event.preventDefault();
        var profileAccountType = $(this).attr('data-type');
        $('.switch-account-btn span').html(profileAccountType);
        $('.profile-switch .profile-account.active').removeClass('active');
        $(this).addClass('active');

        $('.wallet .title').html(profileAccountType);
        $('.wallet .sub-title').html('-');
        $('.wallet .block-content').html('-');
        $('.wallet .credit-info').remove();

        if($(this).attr('data-id') > 0){
            $('.manage-institute-menu').removeClass('d-none');
        }else{
            $('.manage-institute-menu').addClass('d-none');
        }
    });
    
    $('.switch-ai-model-btn').on('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        $(this).parents('.switch-ai-model').toggleClass('open');
    });

    $('.copy .copy-btn').on('click', function(event){
        event.preventDefault();
        var textToCopy = $(this).closest('.copy').text().replace(/\s+/g, ' ').trim();
        var $this = $(this);
    
        navigator.clipboard.writeText(textToCopy).then(function() {
            $this.addClass('copied');
            setTimeout(function() {
                $this.removeClass('copied');
            }, 2000); 
        }).catch(function(err) {
            console.error('Failed to copy text: ', err);
        });
    });
        
    $(document).on('click', function(event){
        if (!$(event.target).closest('.switch-ai-model').length) {
            $('.switch-ai-model').removeClass('open');
        }
    });

    $('.switch-ai-model-dropdown .option').on('click', function(event){
        event.preventDefault();
        var model = $(this).attr('data-model');
        $('.switch-ai-model-dropdown .option.active').removeClass('active');
        $(this).addClass('active');
        $('.switch-ai-model').removeClass('open');
        $('.switch-ai-model-btn-content .title span').html( model );
        $('.switch-ai-model').addClass('processing');
    });


 
    app.datatable = {}

    app.datatable.tables = [];

    $('[act-datatable]').each(function () {

        var datatableElement = $(this);
        var datatableUrl = $(this).attr("act-datatable");
        var datatableSort = $(this).attr("act-sort");

        if (datatableSort) {
            datatableSort = JSON.parse(datatableSort);
        } else {
            datatableSort = [[0, "desc"]];
        }

        var datatableSearch = $(this).attr("search");
        var columns = [];
        var count = $('thead tr th', datatableElement).length;
        $('thead tr th', datatableElement).each(function (i) {
            var nameAttr = $(this).attr('name');
            var responsivePriority = $(this).attr('priority');

            if (responsivePriority === 'undefined') {
                responsivePriority = 0;
            }

            columns.push({
                'data': nameAttr,
                'name': nameAttr,
                'responsivePriority': responsivePriority
            });

            if (i + 1 === count) {
                var datatableObj = datatableElement.DataTable({
                    processing: true,
                    serverSide: true,
                    bLengthChange: false,
                    responsive: false,
                    autoWidth: false,
                    iDisplayLength: 10,
                    order: datatableSort,
                    searchDelay: 1000,
                    oSearch: {
                        'sSearch': $(datatableSearch).val()
                    },
                    language: {
                        zeroRecords: "No records yet. Let's get started! 🚀",
                    },
                    ajax: {
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        url: datatableUrl,
                        data: function (d) {

                            $('.datatable-fliter').each(function () {
                                d[$(this).attr('name')] = $(this).val();
                            });

                        },
                        type: 'POST',
                        error: function error(jqXHR, textStatus, errorThrown) {
                            $('.dataTables_processing').hide();
                        }
                    },
                    drawCallback: function (settings) {
                        $('#' + settings.sTableId).act(config);

                        $('.dtlink .view-btn').each(function () {
                            let link = $(this).attr('href');
                            $(this).closest('tr').find('td:not(:first-child)').click(function () {
                                window.location.href = link;
                            });
                        });

                    },
                    columns: columns,
                    aaSorting: [[0, 'desc']],
                });

                if (datatableSearch) {
                    $(datatableSearch).on('change, keyup', function (e) {
                        if (e.which == 13) {
                            datatableObj.search($(this).val()).draw();
                        }
                    });
                }

                $('.datatable-fliter').on('change', function () {
                    datatableObj.draw();
                });

                $('.filter.search .btn').on('click', function(){
                    datatableObj.search($(datatableSearch).val()).draw();
                });

                app.datatable.tables.push(datatableObj);
            }
        });

    });

    $('.repeater').each(function () {
        let initEmpty = false;
        if ($(this).attr('data-init-empty') == 'true') {
            initEmpty = true;
        }
        
        $(this).repeater({
            initEmpty: initEmpty,
            show: function () {
                $(this).act(config);
                $(this).slideDown();
                $(".section-count").each(function (index) { $(this).html(index + 1); });
                $('[default-value]').each(function () {
                    $(this).val($(this).attr('default-value'));
                });
            },
            hide: function (deleteElement) {
                $(this).slideUp(deleteElement);
                setTimeout(function () {
                    $(".section-count").each(function (index) { $(this).html(index + 1); });
                }, 1000);
            },
            repeaters: [{
                selector: '.inner-repeater',
                show: function () {
                    $(this).act(config);
                    $(this).slideDown();
                    $(this).find('select').select2();
                    $(".section-count").each(function (index) { $(this).html(index + 1); });
                    $('input[default-value]').each(function () {
                        $(this).val($(this).attr('default-value'));
                    });
                },
                hide: function (deleteElement) {
                    $(this).slideUp(deleteElement);
                    setTimeout(function () {
                        $(".section-count").each(function (index) { $(this).html(index + 1); });
                    }, 1000);
                },
                isFirstItemUndeletable: true
            }],
            isFirstItemUndeletable: true
        });
    });

    
    Quill.register({
        'modules/tableUI': quillTableUI.default
    }, true);

    var BaseImageFormat = Quill.import('formats/image');
    const ImageFormatAttributesList = [
        'alt',
        'height',
        'width',
        'style'
    ];

    class ImageFormat extends BaseImageFormat {
    static formats(domNode) {
        return ImageFormatAttributesList.reduce(function(formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
            formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
        }, {});
    }
    format(name, value) {
        if (ImageFormatAttributesList.indexOf(name) > -1) {
        if (value) {
            this.domNode.setAttribute(name, value);
        } else {
            this.domNode.removeAttribute(name);
        }
        } else {
        super.format(name, value);
        }
    }
    }

    Quill.register(ImageFormat, true);

    app.enableQuill = function destory_editor(element){
        $(element).find('.richtext-editor').each(function(index) {
            if(!$(this).hasClass('ql-container')){
                const quill = new Quill(this, {
                    theme: 'snow',
                    modules: {
                        imageResize: {
                            displaySize: true
                        },
                        clipboard: {
                            matchVisual: true,
                        },
                        table: true,
                        tableUI: true,
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike', { 'align': [] }, { 'script': 'sub'}, { 'script': 'super' }, 'formula', 'table', 'image'],
                            ['clean']
                        ]
                    },
                    formats: [
                        'img'
                    ],
                });
            
                $(quill.root).on('focus', function() {
                    $('.ql-toolbar').css('z-index', 99);
                    const toolbar = $(this).closest('.ql-container').prev('.ql-toolbar');

                    if (toolbar) {
                        toolbar.css('z-index', 101);
                    }
                });
        
                quill.on('text-change', function(delta, oldDelta, source) {
                    $(quill.container).find('.ql-editor').trigger('input');
                });
                
                quill.container.querySelector('.ql-editor').addEventListener('keydown', function (event) {
                    if (event.key === ' ' && event.repeat) {
                    event.preventDefault();
                    document.execCommand('insertHTML', false, '&nbsp;');
                    }
                });

                const linkHTML = '<div class="link">You can use the <a href="https://visualmatheditor.equatheque.net/VisualMathEditor.html?runLocal&codeType=Latex&encloseAllFormula=false&style=aguas&localType=en_US&equation=%5Cvec{F}%20=%20%5Cfrac{d%20%5Cvec{p}}{dt}%20=%20m%20%5Cfrac{d%20%5Cvec{v}}{dt}%20=%20m%20%5Cvec{a}" target="_blank">Visual Math Editor</a> to enter formulas.</div>';
                $(quill.container).find('.ql-tooltip').append(linkHTML);
                
            }
        });
    }

    app.disableQuill = function destory_editor(element){
        $(element).find('.richtext-editor').each(function(index) {
            var content = $(this).find('.ql-editor').html();
            $(this).html(content);
    
            $(this).siblings('.ql-toolbar').remove();

            $(this).removeClass (function (index, class_name) {
                return (class_name.match (/(^|\s)ql-\S+/g) || []).join(' ');
             });
        });
    }
 
    app.reset = function(){
        $('form').trigger('reset');
        $('.select2').trigger('change');
        $('.custom-file-label').html('Choose file');
        $('[reset-src]').each(function (index) {
            $(this).attr('src', $(this).attr('reset-src'));
        });
    }

    var config = {
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        init: function (element) {

            // On load, set the value of each .save-preferences element from the cookie
            $('[save-preferences]', element).each(function() {
                var name = $(this).attr('name');
                if (name) {
                    var cookieName = 'preference_' + name;
                    var value = Cookies.get(cookieName);
                    if (value) {
                        value = JSON.parse(value);
                        if ($(this).is('select')) {
                            $(this).val(value).trigger('change');
                        } else if ($(this).is('input[type=checkbox], input[type=radio]')) {
                            $(this).prop('checked', value);
                        } else {
                            $(this).val(value);
                        }
                    }
                }
            });
        
            // Listen for changes on elements with class .save-preferences
            $('[save-preferences]', element).on('change', function() {
                var name = $(this).attr('name');
                var cookieName = 'preference_' + name;
                var value;
        
                if ($(this).is('input[type=checkbox]')) {
                    value = $(this).is(':checked');
                } else {
                    value = $(this).val();
                }
        
                if (name) {
                    Cookies.set(cookieName, JSON.stringify(value));
                }
            });
        
            
            // $('[type="submit"]', element).prop('disabled', false);
            $(".select2:not(#create-form .select2, #edit-form .select2)", element).select2();
            $('#create-form .select2', element).select2({ dropdownParent: "#create-form" });
            $('#edit-form ').find('.select2', element).select2({ dropdownParent: "#edit-form" });


            Inputmask({ placeholder: '' }).mask($('.input-mask', element));

            $('.avoid-space', element).on('keydown', function(e) {
                if (e.keyCode === 32) {
                    e.preventDefault();
                }
            });

            $('.datepicker', element).datepicker({
                'format': 'dd-mm-yyyy'
            });

            $('.datepicker', element).on('changeDate', function (ev) {
                $(this).datepicker('hide');
            });

            app.enableQuill(element);

            $('[data-bs-toggle="tooltip"]', element).on('mouseover', function () {
                $(this).tooltip({ trigger: 'manual' }).tooltip('show');
            });

            $('[data-bs-toggle="tooltip"]', element).on('mouseleave', function () {
                $(this).tooltip({ trigger: 'manual' }).tooltip('hide');
            });

            $('.template-carousel', element).owlCarousel({
                dots: true,
                items: 4,
                margin: 10,
                nav: false,
                responsive:{
                    0:{
                        items:1,
                    },
                    767:{
                        items:2,
                    },
                    1090:{
                        items:3,
                        nav:true,
                    },
                    1366:{
                        items:4,
                    }

                }
            });

            var owl = $(".welcome-interaction-carousel", element);

            owl.owlCarousel({
                items: 1,
                loop: true,
                margin: 10,
                nav: false,
                autoplay: true,
                autoplayHoverPause: true
            });
        
            $('.welcome-interaction-tab .tab-btn', element).click(function () {
                var position = $(this).data('tab'); // Get the corresponding tab position
                owl.trigger('to.owl.carousel', position); // Change the carousel position
            });
        
            owl.on('changed.owl.carousel', function(event) {
                // Calculate the correct index
                var index = event.item.index - event.relatedTarget._clones.length / 2;
                var itemCount = event.item.count;
                if (index >= itemCount || index < 0) {
                    index = index - Math.floor(index / itemCount) * itemCount;
                }
        
                $('.welcome-interaction-tab .tab-btn', element).removeClass('active'); // Remove active from all tabs
                $('.welcome-interaction-tab .tab-btn[data-tab="' + index + '"]', element).addClass('active'); // Add active to the current tab
            });

 
            $('.auth-carousel', element).owlCarousel({
                dots: false,
                items: 1,
                margin: 10,
                nav: false,
                loop: true,
                autoplay: true,
            });

            $('.custom-file-input', element).change(function (e) {
                if (e.target.files && e.target.files[0]) {
                    var reader = new FileReader();
                    var target = $(this).closest('.custom-file');
                    target.find('.custom-file-label').html(e.target.files[0].name);
                    target.find('.custom-file-remove').removeClass('d-none');
                    target.find('.custom-file-remove.soft').bind("click", function (e) {
                        e.preventDefault()
                        var target = $(this).closest('.custom-file');
                        target.find('.custom-file-label').html('Choose file');
                        target.find('.custom-file-input').val('');
                        target.find('.custom-file-preview').attr('src', target.find('.custom-file-preview').attr('default-src'));
                        $(this).addClass('d-none');
                    });
                    reader.onload = function (e) {
                        target.find('.custom-file-preview').attr('src', e.target.result);
                        target.find('.custom-file-preview').hide().fadeIn(650);
                    }
                    reader.readAsDataURL(e.target.files[0]);
                }
            });

            $(":reset", element).on('click', function () {
                app.reset();
            });

 
            $('form', element).on("change", '.smart-checkbox input[type="checkbox"]', function (event) {
                var checkboxMaxCount = parseInt($(this).closest('form', element).attr('data-checkbox-count'));
                var currentIdentity = $(this).attr('identity');
            
                // Disable or uncheck other checkboxes with the same identity value
                if ($(this).is(':checked')) {
                    $('.smart-checkbox input[type="checkbox"][identity="' + currentIdentity + '"]', element).not(this).prop('checked', false).prop('disabled', true);
                } else {
                    $('.smart-checkbox input[type="checkbox"][identity="' + currentIdentity + '"]', element).prop('disabled', false);
                }
            
                // Original code for handling max checkbox count
                if ($('.smart-checkbox input[type="checkbox"]:checked', element).length > checkboxMaxCount) {
                    $(this).prop('checked', false);
                }
            
                if ($('.smart-checkbox input[type="checkbox"]:checked', element).length == checkboxMaxCount) {
                    $('#smart-checkbox-save').prop('disabled', false);
                } else {
                    $('#smart-checkbox-save').prop('disabled', true);
                }
            });            

        },
        respond: function (act, element, json) {
            if (json.datatable) {
                if (json.datatable.reload) {
                    $.each(app.datatable.tables, function (index, table) {
                        table.ajax.reload(null, false);
                    });
                }
            }

            if (json.reset) {
                app.reset();
            }

            if (json.modal) {
                if (json.modal.hide) {
                    $(json.modal.hide).modal('hide');
                }
                if (json.modal.show) {
                    $(json.modal.show).modal('show');
                }
            }
        }
    }

    act = $('html').act(config);
});